import { Component, OnInit } from '@angular/core';
//import * as $ from 'jquery';
//import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import {  Router } from "@angular/router";
import { Globals } from 'app/globals';
import { AdminService } from 'app/services/admin/AdminService';
import { AssessmentsService } from '../../services/assessment/AssessmentsService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
declare var jquery: any;
declare var $: any;
import { ToastrService } from 'ngx-toastr';
// import { forEach } from '@angular/router/src/utils/collection';


@Component({
  selector: 'app-assessment-eli',
  templateUrl: './assessment-eli.component.html',
  styleUrls: ['./assessment-eli.component.scss']
})
export class AssessmentEliComponent implements OnInit {
    assessments: any[] = [];
    assessmentsHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    assessmentType: number = 1;

    height: number;
    count: number;

    loading: boolean = true;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;
    assessmentsTypes: any[] = [];
    prices: any[] = [];


    constructor(
        private _AdminService: AdminService,
        private _AssessmentsService: AssessmentsService,
        private router: Router,
        private _Globals: Globals,
        private _CryptoJs: CryptoJs,
        private toastr: ToastrService
    )
    {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
      this.gridOptions = <GridOptions>{};
      this.gridOptions.rowHeight = 45;
      this.gridOptions.headerHeight = 40;

      this.assessmentsHeaders = this.createHeaders();

        this.refresh(); 
    }

    GetAssessments() {
      this.loading = true;
        this._AdminService.getAssessments().subscribe((data: any) => {
          console.log('getAssessments', data.result);
          if (this._Globals.validationToken(data.result.Result)) {
              let _data = JSON.parse(data.result.Data);
              this.assessments = _data;
              this.loading = false;
          }          
      });
    }

    refresh() {
        this.GetAssessments();
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount > 0) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.router.navigate(['/app/edit_eli', id]); 
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            this.getSelectedRows();
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            this.sizeToFit();
        }, 500);
    }
    
    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            sort: 'asc',
            minWidth: 200,
            width: 200,
            hide: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        //let actionsHeader = {
        //   headerName: 'Actions',
        //   field: '',
        //   width: 85,
        //   minWidth: 85,
        //   suppressSizeToFit: true,
        //   suppressSorting: true,
        //   suppressMenu: true,
        //   cellRenderer: function (params) {
        //       let content = '';

        //       content += '<i id="editAction" class="material-icons custom-icons">edit</i>';

        //       content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

        //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //   }
        //};
        //columnDefs.push(actionsHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'NicheName',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version', 
        //    field: '',
        //    minWidth: 100,
        //    width: 100,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.data.MajorVersion + '.' + params.data.MinorVersion;
        //    }
        //};
        //columnDefs.push(versionHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.edit(data['Id']);

           //switch (e.event.target.id) {
           //    case "editAction":
           //        {
           //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
           //            this.edit(data['Id']);
           //            break;
           //        }

           //    case "deleteAction":
           //        {
           //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
           //            this.delete();
           //            break;
           //        }
           //}
        }
    }

    edit(id: number) {
       console.log('edit');
       this.router.navigate(['/app/edit_eli', id]);
    }

    delete() {
       console.log('delete');
    }

    showPricingModal() {
        $("#pricingModal").modal({ backdrop: "static" });
        $('#pricingModal').modal('show');
    }

    closePricingModal() {
        $('#pricingModal').modal('hide');
    }

    getAssessmentTypes() {
        this._AdminService.getAssessments().subscribe((data: any) => {
            console.log('getAssessments', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.assessmentsTypes = _data;
                console.log(_data);

                if (_data.length > 0) {
                    this.showPricingModal();
                    this.getAssessmentPricing(_data[0].Id);
                } else {
                    this.toastr.error("We are sorry.  I'm unexpected error happened while trying to get the assessment pricing", 'ELI');
                    this.closePricingModal();
                }
                
            }
        })
    }

    getAssessmentPricing(assessmentId) {
        this._AssessmentsService.getAssessmentPricing(parseInt(assessmentId)).subscribe((data: any) => {
            console.log('getAssessmentPricing', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                this.prices = JSON.parse(this._CryptoJs.decrypt(data.result.Data, 'Ps6v7y$B&E!H@McKfTj9nZ34t7w!z%8*'));
                console.log('this.prices', this.prices);
            }
        })
    }

    saveAssessmentPricing(assessmentId) {
        //[
        //    { "RangeStart": 1, "RangeEnd": 10, "Price": 10 },
        //    { "RangeStart": 11, "RangeEnd": 20, "Price": 11 },
        //    { "RangeStart": 21, "RangeEnd": 30, "Price": 12 },
        //    { "RangeStart": 31, "RangeEnd": 0, "Price": 14 }
        //]
        let pricingData = [];

        this.prices.forEach((price, index) => {
            console.log('index: ' + index, price);

            pricingData.push({
                "RangeStart": price.RangeStart,
                "RangeEnd": (price.RangeEnd === "+" ? "0" : price.RangeEnd),
                "Price": parseInt($('#price' + index).val())
            });
        });
       
        let encryptedPricingData = JSON.stringify(pricingData);

        console.log('assessmentId', assessmentId);
        console.log('encryptedPricingData', encryptedPricingData);

        this._AssessmentsService.saveAssessmentPricing(parseInt(assessmentId), this._CryptoJs.encrypt(encryptedPricingData, 'Os6v7y$B&E!H@McKfTj9nZ34tPw!z%8*')).subscribe((data: any) => {
            console.log('saveAssessmentPricing', data.result);
            if (this._Globals.validationToken(data.result.Result)) {

                if (data.result.Result == 1) {
                    this.toastr.success("Assessment pricing info successfully saved", 'ELI');
                } else {
                    this.toastr.error("We are sorry. An unexpected error happened while trying to update the assessment pricing info", 'ELI');
                }
            }
        });
    }

    preventFirst0(evt: any) {
        var charCode = evt.keyCode;
        //console.log(charCode);
        if (parseInt(evt.target.value) <= 0 || evt.target.value == "") {
            $('#' + evt.target.id).val(1);
            return false;
        } else {
            return true;
        }
    }



}
